import axios from '@/utils/fetch'
const version = 'v1.0';
const _module_weixin = `weixin/${version}/wechat`

export default {
    // 获取微信登录的appid
    getAppid(params) {
        return axios({
            url: `${_module_weixin}/app/${params}`,
            method: "GET",
            loading: false,
        })
    },
    //     GET /v1.0/wechat/open/authorize_url
    // 获取微信公众号授权第三方平台链接
    // , // 服务条款
    authorize_url() {
        return axios({
            url: `${_module_weixin}/open/authorize_url`,
            method: 'GET',
            loading: false,
        })
    },
    // GET /v1.0/wechat/open/authorize_notify
    // 微信授权回调(SUNNY_H5)
    authorize_notify(data) {
        return axios({
            url: `${_module_weixin}/open/authorize_notify`,
            method: 'POST',
            loading: false,
            data
        })
    },

    // GET /v1.0/wechat/open/get_address_by_ip
    get_address_by_ip() {
        return axios({
            url: `${_module_weixin}/open/get_address_by_ip`,
            method: 'GET',
            loading: false,
        })
    },

    // GET /v1.0/wechat/open/get_access_token
    // 通过code和appid获取accessToken和openid
    get_access_token() {
        return axios({
            url: `${_module_weixin}/open/get_access_token`,
            method: 'GET',
            loading: false,
        })
    },
    // GET /v1.0/wechat/open/get_access_token_by_code
    // 通过code和appid获取用户基本信息
    get_access_token_by_code(params) {
        return axios({
            url: `${_module_weixin}/open/get_access_token_by_code`,
            method: 'GET',
            loading: false,
            params
        })
    },
    // GET /v1.0/wechat/open/quick_login_url
    // 获取第三方平台快捷登录地址
    quick_login_url() {
        return axios({
            url: `${_module_weixin}/open/quick_login_url`,
            method: 'GET',
            loading: false,
        })
    },
    // GET /v1.0/wechat/open/get_user_info
    // 通过access_token和openid获取用户基本信息
    get_user_info() {
        return axios({
            url: `${_module_weixin}/open/get_user_info`,
            method: 'GET',
            loading: false,
        })
    },
    // GET /v1.0/wechat/open/sign_package
    // 获取签名参数
    sign_package(data) {
        return axios({
            url: `${_module_weixin}/open/sign_package`,
            method: 'POST',
            loading: false,
            data
        })
    },
}


// WEBPACK FOOTER //
// ./src/apis/src/wechat.js